import { TextSpan, type TextSpanProps } from "components/text-label";
import styled from "styled-components";

type DescriptionTextProps = TextSpanProps & {
  $fontSize?: string;
  $fontWeight?: number;
};

export const DescriptionText = styled(TextSpan).attrs<DescriptionTextProps>(
  (props: DescriptionTextProps) => ({
    display: "block",
    color: props.color ?? "#292929",
  })
)`
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  text-align: justify;
  line-height: 150%;
  font-size: ${({ $fontSize }) => $fontSize ?? "0.656rem"};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? 400};
`;

export const BorderError = styled.div`
background-color: #FFEAEA;
height:40px;
justify-content: center;
align-items: center;
display: flex;
width: 40px;
border-radius: 99px;
`;

export const ContentError = styled.div`
align-items: center;
display: flex;
flex-direction: column;
gap: 8px;
`;

export const ButtonUnset = styled.button`
  all: unset;
  background-color: transparent;
  cursor: pointer;
`;

export const HighlightBox = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: #abc3e7;
  background-color: #abc3e752;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
`;

export const SectionContent = styled.div`
  flex: 1;
  padding-bottom: 12px;
  padding-top: 12px;
  border-bottom: 1px solid #E5E7EB;
  gap: 6px;
  display: flex;
  flex-direction: column;
`;

export const Alert = styled.span`
  width: 29px;
  text-align: center;
  margin: auto 0;
`;
export const AlertContent = styled.p`
  font-size: 32px;
  font-weight: var(--font-weight-semibold);
  color : #eb1a21;
  margin: auto 0;
`;
